var _circle, _circle2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeTarget48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2365,
    y1: 7.2365,
    x2: 39.7635,
    y2: 39.7635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    stroke: "#464646",
    strokeMiterlimit: 10,
    cx: 23.5,
    cy: 23.5,
    r: 23
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#147391",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 23.5,
    cy: 23.5,
    r: 14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.5,
    y1: 5,
    x2: 23.5,
    y2: 19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.5,
    y1: 28,
    x2: 23.5,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 28,
    y1: 23.5,
    x2: 42,
    y2: 23.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#147391",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 5,
    y1: 23.5,
    x2: 19,
    y2: 23.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeTarget48);
export default __webpack_public_path__ + "static/media/typeTarget48.0b1197997a8a76de5fe97c518b6e98a9.svg";
export { ForwardRef as ReactComponent };